import { FC } from 'react';
import { ACCESS_FLAGS } from 'constants/config';
import { defaultFn } from 'constants/index';
import { useAppSelector } from 'hooks/toolkit';
import SelectedAccount from 'modules/single-transfer/thirdPartyPayouts/steps/common/SelectedAccount';
import { getSelectedSourceAccountCardProps } from 'modules/single-transfer/thirdPartyPayouts/thirdPartyPayouts.utils';
import { RootState } from 'store';
import { defaultFnType } from 'types';
import { getBeneIcon } from 'utils/beneficiary';

interface SelectedAccountsProps {
  wrapperClassName?: string;
  wrapperStyle?: string;
  recipientAccount?: any;
  sourceAccount?: any;
  recipientProps?: any;
  sourceProps?: any;
  isSummary?: boolean;
  onRecipientClick?: defaultFnType;
  onSourceClick?: defaultFnType;
  isBulk?: boolean;
  isRecipientAccount?: boolean;
}

const SelectedAccounts: FC<SelectedAccountsProps> = ({
  wrapperClassName = 'tw-w-full',
  wrapperStyle = '',
  recipientAccount = null,
  sourceAccount = null,
  recipientProps = {},
  sourceProps = {},
  isSummary = false,
  onRecipientClick = defaultFn,
  onSourceClick = defaultFn,
  isBulk = false,
  isRecipientAccount = false,
}) => {
  const { userAccessFlags } = useAppSelector((state: RootState) => state.user);
  const isBizbankingEnabled = userAccessFlags?.[ACCESS_FLAGS.IS_BUSINESS_BANKING_ENABLED];
  const isMeaView = isBizbankingEnabled || isBulk;

  return (
    <div className={`${wrapperClassName} ${wrapperStyle}`}>
      {!!recipientAccount && (
        <SelectedAccount
          wrapperStyle={isSummary ? 'tw-mb-4' : 'tw-mb-3'}
          labelProps={{
            title: 'Paying to',
          }}
          cardProps={{
            ...(isRecipientAccount
              ? getSelectedSourceAccountCardProps({ sourceAccount: recipientAccount, isMeaView })
              : {
                  title: recipientAccount?.beneficiary_name,
                  subtitle: recipientAccount?.beneficiary_account_number,
                  iconPath: getBeneIcon(recipientAccount),
                }),
            onClick: isSummary ? defaultFn : onRecipientClick,
          }}
          isSummary={isSummary}
          editClick={isSummary ? onRecipientClick : defaultFn}
          {...recipientProps}
        />
      )}

      {!!sourceAccount && (
        <SelectedAccount
          wrapperStyle={isSummary ? 'tw-mb-4' : 'tw-mb-2'}
          labelProps={{
            title: 'Paying from',
          }}
          cardProps={{
            ...getSelectedSourceAccountCardProps({ sourceAccount, isMeaView }),
            onClick: isSummary ? defaultFn : onSourceClick,
          }}
          isSummary={isSummary}
          editClick={isSummary ? onSourceClick : defaultFn}
          {...sourceProps}
        />
      )}
    </div>
  );
};

export default SelectedAccounts;
